import React from 'react';
import { validateContent } from './contentValidation';
import ValidationDisplay from '../ValidationDisplay';

interface ContentValidationCardProps {
    data: Record<string, any>[];
}

const ContentValidationCard: React.FC<ContentValidationCardProps> = ({ data }) => {
    if (data.length === 0) {
        return null;
    }

    const validationResult = validateContent(data);

    return (
        <ValidationDisplay 
            checks={validationResult.checks} 
            isValid={validationResult.isValid}
            showEmailAction={true}
        />
    );
};

export default ContentValidationCard;
